import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/** How `AppDialogService.open` presents a dialog; `data` is handed to the opened component. */
export interface AppDialogOptions<TData> {
	data?: TData;
	/** Whether the dialog renders its own header bar with a close button. */
	showHeader?: boolean;
	/** Whether a click on the backdrop closes the dialog. */
	dismissableMask?: boolean;
	/** Whether Escape closes the dialog. */
	closeOnEscape?: boolean;
}

/**
 * Handle of an open dialog, returned by `AppDialogService.open` and injectable in the opened component.
 * `close(result)` closes the dialog; `closed` emits that result, or `undefined` for a close without one.
 */
export abstract class AppDialogRef<TResult = unknown> {
	abstract readonly closed: Observable<TResult | undefined>;

	abstract close(result?: TResult): void;
}

/** The `data` of the dialog options, injectable in the opened component: `inject<MyData>(APP_DIALOG_DATA)`. */
export const APP_DIALOG_DATA = new InjectionToken<unknown>('APP_DIALOG_DATA');

/**
 * The id of the opened component's title, which names the dialog (its `aria-labelledby`); injectable in the opened
 * component, which gives it to its title element (`app-modal` gives it to its title heading).
 */
export const APP_DIALOG_TITLE_ID = new InjectionToken<string>('APP_DIALOG_TITLE_ID');
